export default {
    "en": {
        "general": {
            "greetings": "How are you today?",
            "ahim_capabilities": "AHIM Capabilities",
            "how_it_works": "How it works",
            "coming_soon": "Coming soon",
            "why_choose_ahim": "Why choose AHIM",
            "section_3_header": "Why choose AHIM",
            "section_3_title": "One Platform. One Intelligence Layer. One Healthcare Ecosystem.",
            "result_benefit_1": "Faster access to care",
            "result_benefit_2": "Better clinical decisions",
            "result_benefit_3": "Lower healthcare costs",
            "result_benefit_4": "Scalable national health infrastructure"
        },
        "languages": {
            "en": "English",
            "fr": "French"
        },
        "menu": {
            "ahim_capabilities": "AHIM Capabilities",
            "how_ahim_works": "How AHIM works",
            "why_choose_ahim": "Why choose AHIM",
            "contact": "Contact",
            "contact_us": "Contact Us"
        },
        "abbrev": {
            " month": "Dec."
        },
        "alt": {
            " month": "December"
        },
        "String to return when truncating text": "%(truncated_text)s…"
    },
    "fr": {
        "general": {
            "greetings": "Comment allez-vous",
            "ahim_capabilities": "AHIM Capabilities",
            "how_it_works": "How it works",
            "coming_soon": "Bientôt disponible",
            "why_choose_ahim": "Why choose AHIM",
            "section_3_header": "Why choose AHIM",
            "section_3_title": "One Platform. One Intelligence Layer. One Healthcare Ecosystem.",
            "result_benefit_1": "Faster access to care",
            "result_benefit_2": "Better clinical decisions",
            "result_benefit_3": "Lower healthcare costs",
            "result_benefit_4": "Scalable national health infrastructure"
        },
        "languages": {
            "en": "English",
            "fr": "French"
        },
        "menu": {
            "ahim_capabilities": "AHIM Capabilities",
            "how_ahim_works": "How AHIM works",
            "why_choose_ahim": "Why choose AHIM",
            "contact": "Contact",
            "contact_us": "Contactez-nous"
        },
        "abbrev": {
            " month": "Dec."
        },
        "alt": {
            " month": "December"
        },
        "String to return when truncating text": "%(truncated_text)s…"
    }
};
